import Axios from "axios";
import {
    SET_MONTHLY_SALARY_REPORT_LIST, 
    UNSET_MONTHLY_SALARY_REPORT_LIST
} from "@/store/mutation-types";
import {
    getMonthlySalaryReport,
} from "@/store/api";

const state = {
    getMonthlySalaryReport: [],
};

const getters = {
    getMonthlySalaryReport(state) {
        return state.getMonthlySalaryReport;
    },
};

const mutations = {
    [SET_MONTHLY_SALARY_REPORT_LIST](state, data) {
        state.getMonthlySalaryReport = data;
    },
    [UNSET_MONTHLY_SALARY_REPORT_LIST](state) {
        state.getMonthlySalaryReport = [];
    },
};

const actions = {

    getMonthlySalaryReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getMonthlySalaryReport}`, { params: data })
                .then((response) => {
                    commit(SET_MONTHLY_SALARY_REPORT_LIST, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_MONTHLY_SALARY_REPORT_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
    

};


export default {
    state,
    getters,
    actions,
    mutations,
};